import './App.css';
import { useState, useEffect, createContext, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Header from './Components/Header/header';

import Perfil from './Pages/Perfil/Perfil';
import Home from './Pages/Home/Home';
import Modulos from './Pages/Modulos/Modulos';
import ModuloHome from './Pages/Modulos/ModuloHome';
import Material from './Pages/Material/Material';
import Empresas from './Pages/Empresas/Empresas';
import Chat from './Pages/Chat/Chat';
import Calendario from './Pages/Calendario/Calendario';

import AdminModulos from './Pages/Admin/AdminModulos/AdminModulos';
import AdminUsuarios from './Pages/Admin/AdminUsuarios/AdminUsuarios';
import Practicas from './Pages/Practicas/Practicas';

import keycloakAPI, { initKeycloak } from './keycloak/keycloakAPI';
import { UsuarioApi } from './api/UsuarioApi';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';

export const UserContext    = createContext();
export const SetUserContext = createContext();

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [keycloakInitialized, setKeycloakInitialized] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [user, setUser] = useState(null);
  const [isInFinalizadaFormacion, setIsInFinalizadaFormacion] = useState(false);
  const [isInFasePractica, setIsInFasePractica] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const navbarRef = useRef(null);

  useEffect(() => {
    initKeycloak()
      .then(authenticated => {
        setIsAuthenticated(authenticated);
        setKeycloakInitialized(true);

        if (authenticated) {
          const tokenParsed = keycloakAPI.tokenParsed;
          const userId    = tokenParsed?.sub;
          const username  = tokenParsed?.preferred_username || 'Usuario';
          const email     = tokenParsed?.email || '';
          const firstName = tokenParsed?.given_name || '';
          const lastName  = tokenParsed?.family_name || '';
          const roles     = tokenParsed?.resource_access?.['accesos-formacion']?.roles || [];
          const isAdmin   = roles.includes('admin');
          const groups    = roles.includes('finalizada-formacion');

          const baseUser = { id: userId, username, email, firstName, lastName, avatarUrl: '', firstRole: isAdmin, groups, roles };
          setUser(baseUser);

          if (groups === true || roles.includes('empresas') || isAdmin) setIsInFinalizadaFormacion(true);
          if (roles.includes('fase-practica') || isAdmin) setIsInFasePractica(true);

          const usuarioApi = new UsuarioApi();
          usuarioApi.verifyUser({ id: userId, username, role: isAdmin ? 'admin' : 'student', email, firstName, lastName })
            .then(() => {
              // Load avatar from DB
              fetch(`${(process.env.REACT_APP_APIURL || 'http://localhost:4000').replace(/\/$/, '')}/usuario/${userId}/profile`)
                .then(r => r.json())
                .then(profile => {
                  setUser(prev => ({
                    ...prev,
                    avatarUrl:  profile.avatar_url  || '',
                    firstName:  profile.first_name  || firstName,
                    lastName:   profile.last_name   || lastName,
                    userTag:    profile.user_tag     || '',
                  }));
                })
                .catch(() => {});
            })
            .catch(() => {});
        }
      })
      .catch(err => console.error('Failed to initialize Keycloak', err));
  }, []);

  useEffect(() => {
    if (keycloakInitialized) {
      const timer = setTimeout(() => setLoaded(true), 100);
      return () => clearTimeout(timer);
    }
  }, [keycloakInitialized]);

  const toggleMenu = () => setSidebar(prev => !prev);

  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setSidebar(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!keycloakInitialized) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
    <div className="App">
      <SetUserContext.Provider value={setUser}>
      <UserContext.Provider value={user}>
        <Router>
          <Header toggleMenu={toggleMenu} />
          <div ref={navbarRef}>
            <Navbar sidebar={sidebar} />
          </div>
          <div className={`main-content ${loaded ? 'loaded' : ''}`}>
            <Routes>
              <Route path="/" element={<ModuloHome />} />
              {isAuthenticated && (
                <>
                  <Route path="/Modulos/:id" element={<Modulos />} />
                  <Route path="/roadmap" element={<Home />} />
                  <Route path="/chat" element={<Chat />} />
                  <Route path="/perfil" element={<Perfil />} />
                  <Route path="/Material/Material" element={<Material />} />
                  {isInFinalizadaFormacion && (
                    <Route path="/empresas/empresas" element={<Empresas />} />
                  )}
                  <Route path="/calendario" element={<Calendario />} />
                  {isInFasePractica && (
                    <Route path="/practicas" element={<Practicas />} />
                  )}
                  {user?.firstRole === true && (
                    <Route path="/Admin/AdminModulos" element={<AdminModulos />} />
                  )}
                  {user?.firstRole === true && (
                    <Route path="/Admin/AdminUsuarios" element={<AdminUsuarios />} />
                  )}
                </>
              )}
            </Routes>
          </div>
        </Router>
      </UserContext.Provider>
      </SetUserContext.Provider>
    </div>
    </ErrorBoundary>
  );
}

export default App;
